import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { ThemeProvider } from './contexts/ThemeContext';

// Context providers
import { AuthProvider } from './contexts/AuthContext';
import { LocationProvider } from './contexts/LocationContext';
import { InventoryProvider } from './contexts/InventoryContext';
import { OrderProvider } from './contexts/OrderContext';
import { CRMProvider } from './contexts/CRMContext';
import { DeliveryProvider } from './contexts/DeliveryContext';

// Route components
import PublicRoute from './components/routes/PublicRoute';
import PrivateRoute from './components/routes/PrivateRoute';

// Public pages
import HomePage from './pages/public/HomePage';
import PricingPage from './pages/public/PricingPage';
import ContactUsPage from './pages/public/ContactUsPage';
import ServicesPage from './pages/public/ServicesPage';
import AboutUsPage from './pages/public/AboutUsPage';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';

// Dashboard layout
import DashboardLayout from './components/layout/DashboardLayout';

// Dashboard pages
import DashboardHome from './pages/dashboard/DashboardHome';
import Orders from './pages/dashboard/Orders';
import Inventory from './pages/dashboard/Inventory';
import Deliveries from './pages/dashboard/Deliveries';
import Customers from './pages/dashboard/Customers';

// Marketing pages
import Leads from './pages/dashboard/marketing/Leads';
import Pipeline from './pages/dashboard/marketing/Pipeline';
import Campaigns from './pages/dashboard/marketing/Campaigns';
import MarketingAnalytics from './pages/dashboard/marketing/MarketingAnalytics';
import MarketingCalendar from './pages/dashboard/marketing/MarketingCalendar';
import MarketingCustomers from './pages/dashboard/marketing/Customers';
import SocialMediaAutomation from './pages/dashboard/marketing/SocialMediaAutomation';
import PersonaManagement from './pages/dashboard/marketing/PersonaManagement';
import Referrals from './pages/dashboard/marketing/Referrals';
import FieldMarketing from './pages/dashboard/marketing/FieldMarketing';

// Profile and Settings
import ProfilePage from './pages/dashboard/ProfilePage';
import SettingsPage from './pages/dashboard/SettingsPage';
import PluginsPage from './pages/dashboard/PluginsPage';

// Plugin pages
import PhotoAdds from './pages/dashboard/plugins/photoAds';
import Storefront3D from './pages/dashboard/plugins/storefront3d';
import AshleyInventory from './pages/plugins/AshleyInventory';
import ShopifySync from './pages/dashboard/plugins/shopify';
// New pages
import Reports from './pages/dashboard/Reports';
import UserManagement from './pages/dashboard/UserManagement';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <LocationProvider>
          <InventoryProvider>
            <OrderProvider>
              <CRMProvider>
                <DeliveryProvider>
                  <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
                  <Routes>
                  {/* Public Routes */}
                  <Route path="/" element={<PublicRoute />}>
                    <Route index element={<HomePage />} />
                    <Route path="pricing" element={<PricingPage />} />
                    <Route path="contact" element={<ContactUsPage />} />
                    <Route path="services" element={<ServicesPage />} />
                    <Route path="about" element={<AboutUsPage />} />
                  </Route>
                  
                  {/* Auth Routes */}
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegisterPage />} />
                  
                  {/* Dashboard Routes */}
                  <Route path="/dashboard" element={<PrivateRoute />}>
                    <Route element={<DashboardLayout />}>
                      <Route index element={<DashboardHome />} />
                      <Route path="customers" element={<Customers />} />
                      <Route path="orders" element={<Orders />} />
                      <Route path="inventory" element={<Inventory />} />
                      <Route path="deliveries" element={<Deliveries />} />
                      <Route path="reports" element={<Reports />} />
                      <Route path="users" element={<UserManagement />} />
                      
                      {/* Marketing Routes */}
                      <Route path="marketing/leads" element={<Leads />} />
                      <Route path="marketing/pipeline" element={<Pipeline />} />
                      <Route path="marketing/campaigns" element={<Campaigns />} />
                      <Route path="marketing/analytics" element={<MarketingAnalytics />} />
                      <Route path="marketing/calendar" element={<MarketingCalendar />} />
                      <Route path="marketing/customers" element={<MarketingCustomers />} />
                      <Route path="marketing/social-media" element={<SocialMediaAutomation />} />
                      <Route path="marketing/personas" element={<PersonaManagement />} />
                      <Route path="marketing/referrals" element={<Referrals />} />
                      <Route path="marketing/field-marketing" element={<FieldMarketing />} />

                      {/* Plugin Routes */}
                      <Route path="plugins/photo-adds" element={<PhotoAdds />} />
                      <Route path="plugins/storefront-3d" element={<Storefront3D />} />
                      <Route path="plugins/ashley-inventory" element={<AshleyInventory />} />
                      <Route path="plugins/shopify-sync" element={<ShopifySync />} />

                      {/* Settings & Profile */}
                      <Route path="profile" element={<ProfilePage />} />
                      <Route path="settings" element={<SettingsPage />} />
                      <Route path="plugins" element={<PluginsPage />} />
                    </Route>
                  </Route>
                  
                  {/* Catch all route */}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                  </Box>
                </DeliveryProvider>
              </CRMProvider>
            </OrderProvider>
          </InventoryProvider>
        </LocationProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
